<template>
  <div class="news-item">

    <div class="item-img">
      <a @click="openNewsDetail(msg.newsId)">
        <img v-lazy="msg.image" :alt="msg.newsTitle">
      </a>
    </div>

    <div class="item-brief">
      <div class="news-title" v-html="msg.newsTitle">{{msg.newsTitle}}</div>
      <div class="news-sub-title">{{msg.newsSubTitle}}</div>
      <div class="news-sub-time">
        {{msg.newsTime}}
        <a @click="openNewsDetail(msg.newsId)">
          <y-button text="阅读更多" style="margin: 0 5px;"></y-button>
        </a>
      </div>
    </div>

  </div>
</template>
<script>
  import YButton from '/components/YButton'
  export default {
    props: {
      msg: {}
    },
    data() {
      return {}
    },
    methods: {
      openNewsDetail(id) {
        window.open('//' + window.location.host + '/#/newsDetail?newsId=' + id)
      }
    },
    computed: {},
    mounted() {},
    components: {
      YButton
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../assets/style/mixin";
  @import "../assets/style/theme";

  .news-item {
    display: flex;
    flex-direction: row;
    border-right: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    background: #fff;
    transition: all .5s;
    padding: 20px 30px;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 1px 1px 20px #999;
    }

    .item-img {
      img {
        margin: auto;
        @include wh(360px, 180px);
        border-radius: 5px;
        display: block;
      }
    }

    .item-brief {
      width: calc(100% - 360px);
      flex: 1;
      padding: 0 30px 0 50px;
      display: flex;
      flex-direction: column;
    }

    .news-title {
      line-height:3;
      font-size: 22px;
      color: #424242;
      white-space: nowrap; // 强制一行显示
      overflow: hidden; // 超出隐藏
      text-overflow: ellipsis; // 省略号
    }

    .news-sub-title {
      font-size: 14px;
      color: #666666;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden; //溢出内容隐藏
      text-overflow: ellipsis; //文本溢出部分用省略号表示
      display: -webkit-box; //特别显示模式
      -webkit-line-clamp: 2; //行数
      line-clamp: 2;
      -webkit-box-orient: vertical; //盒子中内容竖直排列
      margin: 20px 0;
    }

    .news-sub-time {
      flex: 1;
      font-size: 14px;
      color: #999999;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;
    }

  }
</style>



// WEBPACK FOOTER //
// newsItem.vue?f4fcc658